import { isActionOf } from 'typesafe-actions'
import { from, of } from 'rxjs'
import { catchError, filter, mergeMap, map, distinctUntilChanged } from 'rxjs/operators'
import { toast } from 'react-toastify'
import { RootEpic } from '../types'
import {
  getFireblocksAssetBySymbolRequest,
  getFireblocksAssetBySymbolSuccess,
  getFireblocksAssetBySymbolFailure,
} from '../actions'

export const getFireblocksAssetBySymbolEpic: RootEpic = (action$, state$, { getFireblocksAssetBySymbol }) =>
  action$.pipe(
    filter(isActionOf([getFireblocksAssetBySymbolRequest])),
    distinctUntilChanged(
      (prev, curr) =>
        prev.type === curr.type &&
        prev.payload?.symbol === curr.payload?.symbol &&
        prev.payload?.target === curr.payload?.target,
    ),
    mergeMap(({ payload: { symbol, target } }) =>
      from(
        getFireblocksAssetBySymbol({
          token: state$.value.app.authToken as string,
          symbol,
        }),
      ).pipe(
        map((response) => {
          // eslint-disable-next-line
          const pickIcon = (r: any): string | undefined => {
            let media: { url: string; type: string }[] = []
            if (Array.isArray(r?.media) && r.media.length) {
              // eslint-disable-next-line
              media = r.media as any
            } else if (Array.isArray(r?.metadata?.media) && r.metadata.media.length) {
              // eslint-disable-next-line
              media = r.metadata.media as any
            }
            if (!media.length) return undefined
            const byType = (t: string) => media.find((m) => (m.type || '').toLowerCase() === t)
            return byType('image/svg+xml')?.url || byType('image/svg')?.url || byType('image/png')?.url || media[0]?.url
          }
          // eslint-disable-next-line
          const toAsset = (r: any) => ({
            id: r.id as string,
            name: (r.displayName as string) || (r.name as string),
            displayName: (r.displayName as string) || (r.name as string),
            displaySymbol: (r.displaySymbol as string) || (r.symbol as string),
            legacyId: (r.legacyId as string) || (r.id as string),
            iconUrl: pickIcon(r),
          })
          let assets: {
            id: string
            name: string
            displayName?: string
            legacyId?: string
            displaySymbol?: string
          }[]
          if (Array.isArray(response)) {
            // eslint-disable-next-line
            assets = (response as any[])
              .map(toAsset)
              .filter((a) => a.id && (a.displayName || a.name || a.displaySymbol))
          } else if (response) {
            // eslint-disable-next-line
            assets = [toAsset(response as any)]
          } else {
            assets = []
          }

          if (!assets.length) {
            toast.warn('No Fireblocks asset found for symbol')
            return getFireblocksAssetBySymbolFailure({ error: new Error('Not found'), target })
          }

          return getFireblocksAssetBySymbolSuccess({ assets, target })
        }),
        catchError((error: Error) => {
          toast.error('Failed to fetch Fireblocks asset.')
          return of(getFireblocksAssetBySymbolFailure({ error, target }))
        }),
      ),
    ),
  )

export default [getFireblocksAssetBySymbolEpic]
